import { FormActionsMui } from '@app/components/form/FormActionsMui';
import { zodResolver } from '@hookform/resolvers/zod';
import { socialExport } from '@mi-front/api-clients';
import { Grid } from '@mui/material';
import { useMemo } from 'react';
import { FormContainer } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { z } from 'zod';
import { SocialLanguageField } from '../../components/inputs/SocialLanguageField';
import { BaseSettingsFormProps } from '../../hooks/useSocialExportFactory';
import { FormSection } from '../../screens/manage/platforms/FormSection';
import { YoutubeCategoryField } from './YoutubeCategoryField';
import { YoutubeMadeForKidsField } from './YoutubeMadeForKidsField';
import { YoutubePrivacyStatusField } from './YoutubePrivacyStatusField';

const requiredMsg = { id: 'common.required', defaultMessage: 'Requerido' };

export function getYoutubeSettingsSchema(
  t: (msg: { id: string; defaultMessage: string }) => string,
) {
  return z.object({
    privacyStatus: z.string().min(1, t(requiredMsg)),
    language: z
      .string()
      .nullable()
      .optional()
      .transform((val) => (val === '' ? null : val)),
    madeForKids: z.boolean(),
    categoryId: z
      .string()
      .nullable()
      .optional()
      .transform((val) => (val === '' ? null : val)),
  });
}

/** @deprecated Use getYoutubeSettingsSchema(t) for translated messages */
export const youtubeSettingsSchema = getYoutubeSettingsSchema((msg) => msg.defaultMessage);

export function YoutubeSettingsForm({
  stationId,
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<socialExport.YoutubeSettingsDto>) {
  const { $t } = useIntl();
  const schema = useMemo(() => getYoutubeSettingsSchema((msg) => $t(msg)), [$t]);
  return (
    <FormContainer
      mode="onBlur"
      values={{
        language: defaultSettings.language,
        privacyStatus: defaultSettings.privacyStatus,
        madeForKids: defaultSettings.madeForKids,
        categoryId: defaultSettings.categoryId,
      }}
      onSuccess={async (formData) => {
        await onUpdate({
          privacyStatus: formData.privacyStatus,
          madeForKids: formData.madeForKids,
          language: formData.language,
          categoryId: formData.categoryId,
        });
      }}
      resolver={zodResolver(schema)}
    >
      <FormSection
        title={$t({
          id: 'socialExport.form.defaultValuesUploads',
          defaultMessage: 'Valores por defecto para uploads',
        })}
      >
        <Grid container>
          <Grid item md={4}>
            <YoutubePrivacyStatusField />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item md={4}>
            <YoutubeCategoryField stationId={stationId} />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item md={4}>
            <SocialLanguageField />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item md={4}>
            <YoutubeMadeForKidsField />
          </Grid>
        </Grid>
      </FormSection>
      <FormActionsMui cancel />
    </FormContainer>
  );
}
